import Logo from "./Logo";

const FormHeader = ({state}) => {
    const stateKey = state ? state.toLowerCase() : null;

    return (
        <header className="d-flex justify-content-center text-center py-4">
            <Logo size="sm" state={stateKey} />
        </header>
    )
}

export default FormHeader;
